import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { Button, Spin } from 'antd'
import { useHistory } from 'react-router-dom'

import DealDashboardActions from '../../../Redux/DealDashboardRedux'
import PopupWrapper from '../PopupWrapper'
import Images from '../../../Images'
import '../PopupPage.less'

function SendUltimatumPopupPage(props) {
  const { result, fetching, match, isAdmin, location } = props;
  const { dashboardId } = match.params;
  const { state } = location;

  const history = useHistory();

  useEffect(() => {
    props.dealDashboardSyncToggle(false);
    return function cleanup() {
      props.dealDashboardSyncToggle(true);
    }
  }, [0]);

  useEffect(() => {
    if (result) {
      props.getDealDashboardInfo(dashboardId);
      isAdmin ?
				history.push(`/home/match-company/${dashboardId}`)
			:
        history.push(`/deal-dashboard/overview/${dashboardId}/ultimatum-sent`);
    }
  }, [result]);

  const onSubmit = () => {
		if (state?.isHistory) {
			history.push(`/deal-dashboard/overview/${dashboardId}`);
		} else {
      props.sendUltimatumByAdvisor(dashboardId);
    }
	}

  return (
    <PopupWrapper
      width={540}
      path={isAdmin ?
				`/home/match-company/${dashboardId}`
				:
				`/deal-dashboard/overview/${dashboardId}`
			}
    >
      <Spin spinning={fetching} size="large">
        <div className="dialog-content" style={{ padding: '20px 72px 30px' }}>
          <img src={Images.phoneCancel} alt="" />
          <div className="dialog-title welcome" style={{ margin: 8 }}>Send Ultimatum</div>
          <div className="deal-text engagment" style={{ marginTop: 6 }}>By issuing an Ultimatum, the investor will have<br />10 business days to either:</div>
          <div className="textarea">
            <div className="choosefield">
              <b>a)</b> Reject the ultimatum and terminate the engagement
            </div>
            <div className="choosefield">
              <b>b)</b> Accept the ultimatum (Penalty fees applies)
            </div>
            <div className="choosefield">
              <b>c)</b> Submit a Non-Binding offer (NBO)
            </div>
          </div>
          <br />
          <div className="deal-text engagment">Please provide confirmation that you want to <br /> proceed with sending an ultimatum</div>
          <br />
          <div className="deal-text sm" style={{width: '90%'}}>Please review IDN's Platform Agreement to remember your<br />rights and obligations in the context of this engagement</div>
          <div className="btn-footer">
            <Button type="primary white" className="btn-primary welcome" style={{ width: 144 }} onClick={onSubmit}>
              {state?.isHistory ? 'Go back' : 'Confirm'}
            </Button>
          </div>
        </div>
      </Spin>
    </PopupWrapper>
  )
}

const mapStateToProps = (state) => {
  return {
    isAdmin: state.auth.isAdmin,
    result: state.dealDashboard.result,
    fetching: state.dealDashboard.fetching
  }
}

const mapDispatchToProps = (dispatch) => ({
  getDealDashboardInfo: (dashboardId) => dispatch(DealDashboardActions.dealDashboardRequest(dashboardId)),
  sendUltimatumByAdvisor: (dashboardId) => dispatch(DealDashboardActions.advisorSendUltimatumRequest(dashboardId)),
  dealDashboardSyncToggle: (syncIsStart) => dispatch(DealDashboardActions.dealDashboardSyncToggle(syncIsStart)),
})

export default connect(mapStateToProps, mapDispatchToProps)(SendUltimatumPopupPage)
